import {IconContainer} from "@src/components/helper.styled";
import {MouseEventHandler} from "react";

interface RefreshIconProps {
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export const RefreshIcon = ({onClick}: RefreshIconProps) => {
    return (
        <IconContainer $disableMaxHeight={true} onClick={onClick}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6.94439 12C8.35563 12 9.55116 11.516 10.531 10.5479C11.5103 9.57929 12 8.39738 12 7.00214C12 5.6069 11.5103 4.42452 10.531 3.455C9.55164 2.48548 8.35611 2.00048 6.94439 2C6.0859 2 5.28205 2.20167 4.53286 2.605C3.78415 3.00833 3.18061 3.57143 2.72223 4.29429V2H2V5.73571H5.77727V5.02143H3.10501C3.48154 4.30952 4.01069 3.7469 4.69247 3.33357C5.37426 2.92024 6.1249 2.71381 6.94439 2.71429C8.14811 2.71429 9.17127 3.13095 10.0139 3.96429C10.8565 4.79762 11.2778 5.80952 11.2778 7C11.2778 8.19048 10.8565 9.20238 10.0139 10.0357C9.17127 10.869 8.14811 11.2857 6.94439 11.2857C6.01753 11.2857 5.18094 11.0238 4.43464 10.5C3.68833 9.97619 3.16472 9.28571 2.86379 8.42857H2.09678C2.41552 9.4981 3.02075 10.3607 3.91247 11.0164C4.80418 11.6721 5.81482 12 6.94439 12Z"
                    fill="#111113"/>
            </svg>
        </IconContainer>
    )
}